import React from "react";
import { URLS } from "Utils/apiURL";
import { VALIDATE_EMAIL_FIELDS } from "Pages/Dashboard/data-toolkit/constants";
import StatusPill from "Pages/Dashboard/data-toolkit/StatusPill";
import ToolRunner from "Pages/Dashboard/data-toolkit/ToolRunner";

const cellHas = (row, idx) =>
  idx != null && ((row && row[idx]) || "").trim() !== "";

const hasEmailColumn = mapping => mapping.email != null;

// 1 credit per row that has an email to validate; rows without an email are
// skipped (0). We charge only for definitive verdicts at settlement, so this is
// the worst case.
const rowMaxCredits = (row, m) => (cellHas(row, m.email) ? 1 : 0);

const VALIDATE_STATS = (counts, job) => [
  { label: "Valid", value: counts.found || 0 },
  { label: "Risky", value: counts.risky || 0 },
  { label: "Invalid", value: counts.notFound || 0 },
  ...(counts.failed ? [{ label: "Unknown", value: counts.failed }] : []),
  ...(counts.skipped ? [{ label: "Skipped", value: counts.skipped }] : []),
  { label: "Credits used", value: (job && job.creditsCharged) || 0, brand: true }
];

const VALIDATE_COLUMNS = [
  { header: "Result", cell: r => <StatusPill status={r.emailStatus} /> }
];

const CONFIG = {
  toolKey: "VALIDATE_EMAIL",
  iconKey: "validate",
  title: "Validate emails",
  description:
    "Check whether a list of emails is deliverable, risky or invalid. 1 credit per email with a definitive verdict (valid, risky or invalid). Unknown or failed checks are free.",
  fields: VALIDATE_EMAIL_FIELDS,
  endpoint: URLS.dataToolkitValidateEmail,
  runNoun: "Validate emails run",
  runLabel: "Validate emails",
  foundLabel: "Valid",
  inputSub: "Paste one email per line, or upload a CSV with an email column.",
  pastePlaceholder: "email\nelon@tesla.com\nsatya@microsoft.com",
  mappingHint: (
    <>
      Map the column that holds the <b>email addresses</b> you want to check.
    </>
  ),
  requiredCheck: hasEmailColumn,
  requiredError: "Map the column that contains the email addresses.",
  rowCredits: rowMaxCredits,
  costNote: max => (
    <>
      This run will use up to <b>{max.toLocaleString()}</b> email credit
      {max === 1 ? "" : "s"}. You're only charged for a definitive verdict (valid,
      risky or invalid). Unknown or failed checks are free.
    </>
  ),
  stats: VALIDATE_STATS,
  columns: VALIDATE_COLUMNS
};

const ValidateEmails = () => <ToolRunner cfg={CONFIG} />;

export default ValidateEmails;
